var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.2799 18C20.5936 18 23.2799 15.3137 23.2799 12C23.2799 8.68629 20.5936 6 17.2799 6C13.9662 6 11.2799 8.68629 11.2799 12C11.2799 15.3137 13.9662 18 17.2799 18Z",
    fill: "#002F6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.64 18.7C20.39 19.52 18.89 20 17.28 20C15.67 20 14.17 19.52 12.92 18.7C8.72 20.08 5.39 23.4 4 27.6C2.61 31.8 2 34 2 34C2 34 15.5031 34 17.28 34C20.6252 34 32.5 34 32.5 34C32.5 34 31.3543 30 30.56 27.6C29.17 23.4 25.85 20.08 21.64 18.7Z",
    fill: "#002F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageSquare);
export default __webpack_public_path__ + "static/media/NoImageSquare.527d5b2674dd8aab21d9c98a7be2692c.svg";
export { ForwardRef as ReactComponent };